// ============================================================================
// post-client-mod -- useCreatePost Hook
//
// 创建文章的 mutation hook。
// ============================================================================
import { useState, useCallback } from 'react';
import { getPostApiClient } from '../post-api-client.js';
/**
 * 创建文章
 */
export function useCreatePost() {
    const [post, setPost] = useState(null);
    const [creating, setCreating] = useState(false);
    const [error, setError] = useState(null);
    const createPost = useCallback(async (params) => {
        setCreating(true);
        setError(null);
        try {
            const result = await getPostApiClient().createPost(params);
            setPost(result);
            return result;
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '创建文章失败';
            setError(message);
            return null;
        }
        finally {
            setCreating(false);
        }
    }, []);
    const reset = useCallback(() => {
        setPost(null);
        setError(null);
    }, []);
    return { post, creating, error, createPost, reset };
}
//# sourceMappingURL=use-create-post.js.map